/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ xp: NonNullable<unknown> }} Leveling_Reward_Activity_AllInputs */



/**
* | output |
* | --- |
* | "{xp} XP of all time" |
*
* @param {Leveling_Reward_Activity_AllInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_reward_activity_all = /** @type {((inputs: Leveling_Reward_Activity_AllInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Reward_Activity_AllInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.xp} XP за всё время`)
	return /** @type {LocalizedString} */ (`${i?.xp} XP of all time`)
});